import React, { useState } from "react";
import AppLayout from "../components/AppLayout";
import { Mail, Phone, MapPin, Send } from "lucide-react";

function InfoCard({ icon: Icon, title, value, isDark }) {
  return (
    <div
      className={`rounded-3xl border p-5 shadow-sm ${
        isDark ? "border-slate-800 bg-slate-900" : "border-slate-200 bg-white"
      }`}
    >
      <div className="mb-3 flex h-11 w-11 items-center justify-center rounded-2xl bg-sky-100 text-sky-700">
        <Icon className="h-5 w-5" />
      </div>
      <p className={`text-sm ${isDark ? "text-slate-400" : "text-slate-500"}`}>{title}</p>
      <p className={`mt-1 font-semibold ${isDark ? "text-white" : "text-slate-900"}`}>{value}</p>
    </div>
  );
}

function Input({ isDark, ...props }) {
  return (
    <input
      {...props}
      className={`h-12 w-full rounded-2xl border px-4 text-sm outline-none transition focus:border-sky-300 focus:ring-4 focus:ring-sky-100 ${
        isDark
          ? "border-slate-700 bg-slate-950 text-white placeholder:text-slate-500"
          : "border-slate-200 bg-white text-slate-900 placeholder:text-slate-400"
      }`}
    />
  );
}

function Textarea({ isDark, ...props }) {
  return (
    <textarea
      {...props}
      className={`min-h-[140px] w-full rounded-2xl border px-4 py-3 text-sm outline-none transition focus:border-sky-300 focus:ring-4 focus:ring-sky-100 ${
        isDark
          ? "border-slate-700 bg-slate-950 text-white placeholder:text-slate-500"
          : "border-slate-200 bg-white text-slate-900 placeholder:text-slate-400"
      }`}
    />
  );
}

export default function ContactPage({ isDark, setIsDark, currency, setCurrency }) {
  const [sent, setSent] = useState(false);

  return (
    <AppLayout
      isDark={isDark}
      setIsDark={setIsDark}
      currency={currency}
      setCurrency={setCurrency}
      eyebrow="Support"
      title="Contact"
      description="Get in touch with the SpaceM8 team."
    >
      <div className="grid gap-6 xl:grid-cols-[0.9fr_1.1fr]">
        <div className="space-y-6">
          <InfoCard icon={Mail} title="Email" value="info@jisedai.africa" isDark={isDark} />
          <InfoCard icon={Phone} title="Phone" value="+254777 74 8910" isDark={isDark} />
          <InfoCard icon={MapPin} title="Location" value="Nairobi, Kenya" isDark={isDark} />
        </div>

        <div
          className={`rounded-3xl border p-6 shadow-sm ${
            isDark ? "border-slate-800 bg-slate-900" : "border-slate-200 bg-white"
          }`}
        >
          <h2 className={`text-lg font-semibold ${isDark ? "text-white" : "text-slate-900"}`}>
            Send a message
          </h2>
          <p className={`mt-1 text-sm ${isDark ? "text-slate-400" : "text-slate-500"}`}>
            Reach out for product, support, or partnership inquiries.
          </p>

          {sent ? (
            <div
              className={`mt-5 rounded-2xl border px-4 py-3 text-sm ${
                isDark
                  ? "border-emerald-800 bg-emerald-950 text-emerald-300"
                  : "border-emerald-200 bg-emerald-50 text-emerald-700"
              }`}
            >
              Your message has been noted.
            </div>
          ) : null}

          <div className="mt-6 grid gap-4 md:grid-cols-2">
            <Input isDark={isDark} placeholder="Full name" />
            <Input isDark={isDark} placeholder="Email address" type="email" />
          </div>

          <div className="mt-4">
            <Input isDark={isDark} placeholder="Subject" />
          </div>

          <div className="mt-4">
            <Textarea isDark={isDark} placeholder="Your message..." />
          </div>

          <button
            onClick={() => setSent(true)}
            className="mt-5 inline-flex h-12 items-center justify-center rounded-2xl bg-orange-500 px-5 font-medium text-white transition hover:bg-orange-600"
          >
            <Send className="mr-2 h-4 w-4" />
            Send message
          </button>
        </div>
      </div>
    </AppLayout>
  );
}